import classNames from 'classnames'

import { SubscriptionPricing } from '../../../api/services/subscription/types.ts'
import RadioXl from '../../common/forms/Radio/RadioXl.tsx'

const SubscriptionRadioButtons = ({
  label,
  handleRadioChange,
  selectedValue,
  prices
}: {
  label: string
  handleRadioChange: (value: string) => void
  selectedValue: string
  prices: SubscriptionPricing[]
}) => {
  const translateInterval = (interval: string, interval_count: number) => {
    switch (interval) {
      case 'month':
        return interval_count > 1
          ? interval_count > 4
            ? 'miesięcy'
            : 'miesiące'
          : 'miesiąc'
      case 'year':
        return 'rok'
      default:
        return 'nieokreślony'
    }
  }

  return (
    <div className="flex flex-col items-start gap-y-2 sm:gap-8">
      {label}

      {prices.map((plan) => (
        <div
          key={plan.id}
          onClick={() => handleRadioChange(plan.id)}
          className={classNames(
            'flex w-full justify-between px-3 py-4 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none cursor-pointer',
            selectedValue === plan.id
              ? 'border-primary bg-green-200 dark:bg-green-800 dark:border-green-700 text-blue-500 dark:text-blue-300'
              : 'border-gray-300'
          )}
        >
          <div className={'flex flex-row justify-between w-full'}>
            <p className={'px-4'}>
              {'Opłata za '}
              {plan.interval_count +
                ' ' +
                translateInterval(plan.interval, plan.interval_count)}
              {' dostępu'}
            </p>
            <p className={'px-4 text-[22px] font-bold'}>
              {plan.unit_amount.toFixed(2) + ' PLN'}
            </p>
          </div>

          <RadioXl
            id={plan.id}
            name="group1"
            value={plan.id}
            checked={selectedValue === plan.id}
            onChange={handleRadioChange}
            className={'text-[20px]'}
            label={''}
          />
        </div>
      ))}
    </div>
  )
}
export default SubscriptionRadioButtons
